<div
  [cdkTrapFocus]="cdkTrapFocusEnabled"
  class="form-group mb-0 d-flex flex-column flex-grow-1 combo-box-dropdown-spacing"
>
  <ng-container *ngIf="showSearchBar">
    <div class="ps-3 pb-3 pt-2 pe-2">
      <ds-input
        (input)="searchInputChanged()"
        (keydown)="handleKeyInput($event)"
        [(ngModel)]="searchInput"
        [hidePlaceholderWhenFilled]="hideSearchPlaceholderWhenFilled"
        [hidePlaceholderWhenFocused]="hideSearchPlaceholderWhenFocused"
        [placeholder]="searchPlaceholder"
        [showClearButton]="showClearButton"
        iconName="search"
        ngDefaultControl
      >
      </ds-input>
    </div>
  </ng-container>
  <ng-content></ng-content>
  <select
    #select
    [id]="id"
    [multiple]="multiselect"
    class="d-none"
    type="hidden"
  >
    <ng-container *ngIf="comboBoxDropdownGroup">
      <option
        *ngFor="let option of comboBoxDropdownGroup.listItems"
        [selected]="option.isActive"
        [value]="option.value"
      >
      </option>
    </ng-container>
  </select>
</div>
